import { formatBuyType } from '../../liveSession/lib/formatters';

const TYPE_LABELS: Record<string, string> = {
  execute: 'Execute',
  default: 'Default',
  rush: 'Rush',
  retake: 'Retake',
  hold: 'Hold',
};

const ROLE_BLURBS: Record<string, string> = {
  entry: 'Lead the first contact and create space.',
  rifler: 'Stay close and turn contact into a trade.',
  trade: 'Stay close and turn contact into a trade.',
  support: 'Set up your teammates with timed utility.',
  lurker: 'Protect the team from the unexpected.',
  lurk: 'Protect the team from the unexpected.',
  awper: 'Hold the long angle and call what you see.',
  anchor: 'Hold the site and delay the hit.',
  caller: 'Keep all five players on the same timing.',
};

const PLAN_PHASES = ['Prepare', 'Commit', 'Secure'];

export function formatStrategyType(strategyType: string | null | undefined): string {
  if (!strategyType) return '';
  const key = strategyType.trim().toLowerCase();
  return TYPE_LABELS[key] ?? strategyType.trim();
}

export function roleBlurb(name: string): string {
  const key = name.trim().toLowerCase();
  return ROLE_BLURBS[key] ?? 'Follow the plan and stay in touch with the caller.';
}

export function loadoutLabel(buyType: string | null | undefined): string {
  const key = (buyType ?? '').trim().toLowerCase().replace(/[\s-]+/g, '_');
  if (key === 'full_buy' || key === 'full') return 'Rifle + armour';
  if (key === 'half_buy' || key === 'half') return 'SMG + armour';
  if (key === 'eco' || key === 'pistol') return 'Pistol + armour';
  return formatBuyType(buyType);
}

export function formatActionType(actionType: string | null | undefined): string {
  const raw = (actionType ?? '').trim();
  if (!raw) return 'Step';
  const spaced = raw.replace(/[_-]+/g, ' ');
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

export function planPhaseLabel(sortOrder: number): string {
  return PLAN_PHASES[sortOrder - 1] ?? '';
}

export function formatUpdated(iso: string | null | undefined): string {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
}

export function sideName(side: string | null | undefined): string {
  const key = (side ?? '').trim().toUpperCase();
  if (key === 'T') return 'Terrorist';
  if (key === 'CT') return 'Counter-Terrorist';
  return (side ?? '').trim();
}
